<template>
  <ViewEntityContainer :entityName="entityName" :identifier="$route.params.customerId" :getMethod="getCustomerById"
    :refreshOnTimestamp="true" :notificationListeners="[srEventKey]" :notificationValidator="notificationValidator">
  </ViewEntityContainer>
</template>

<script>
import clientAPI from "@/api/ClientAPIMixin.js";
import SRConst from "@/helpers/Constants/SignalRConstants.js";
import ViewEntityContainer from "@/views/pim/suppliers/ViewEntityContainer.vue";
import EntityNames from "@/helpers/Constants/EntityNames.js";

export default {
  name: "ViewCustomerContainer",
  components: {
    ViewEntityContainer,
  },
  mixins: [clientAPI],

  data() {
    return {
      entityName: EntityNames.Customer
    };
  },


  methods: {
    notificationValidator(args, identifier) {
      return args && args.customerId == identifier;
    },
  },

  computed: {
    srEventKey() {
      return SRConst.EventKeys.CustomerChange;
    },
  },

  watch: {},
};
</script>

<style lang="scss" scoped></style>